export default __webpack_public_path__ + "static/island-life-256d169c3412429b6022598ac86e3ca6.webp";